import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
//api
import { getUserBoughtBooks } from "api/orders";
//components
import TitleWithLine from 'components/titleWithLine';
import Head from 'components/metatags_helmet/metatags';
import NoResults from 'components/userzone/NoResults';
//images
import defaultImg from "assets/img/preview.jpg";
import noBooks from "assets/img/ico_nobooks.png";

const MyBooks = ({ data }) => {
  const { t } = useTranslation(['home']);
  const title = t('myBooks', { ns: 'header' });

  return (
    <Container fluid="true" className="margin-top-md mx-3 d-flex mainDiv">
      <Head title={title} noIndex={true} />
      {data?.length > 0 ? (
        <Row>
          <Col lg={12}>
            <TitleWithLine text={title} />
          </Col>
          <div className="d-flex flex-wrap">
            {data?.map(({ is_ebook, cover, titulo, autor, date }, index) => (
              <div className="position-relative" key={`MyBooksItem#${index}`}>
                <div className="img-container shadow-none d-flex justify-content-center">
                  <img src={cover.includes('vacia') ? defaultImg : cover} alt={`${titulo} libro`} />
                </div>
                <div className="markers">
                  {is_ebook && <p className="markers-ebook">EBOOK</p>}
                </div>
                <div className="row img-caption">
                  <div className="col">
                    <h5 className="title limit-long">
                      {titulo.charAt(0).toUpperCase() +
                        titulo.slice(1).toLowerCase()}
                    </h5>
                    <p className="text-center text-black-50">
                      {autor?.pop()?.nombre_autor || "..."}
                    </p>
                    <p className="mt-3 mb-0 text-center text-black-50">
                      {is_ebook ? "EBOOK EPUB" : "RUSTICO"}
                    </p>
                    <p className="text-black-50 text-center">
                      {`${t('purchasedOn')} ${date || "..."}`}
                    </p>
                    {is_ebook && (
                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className=" my-0 mr-1 ml-0 libelistaButtonYellow py-2 px-3  rounded text-uppercase  text-white"
                        >
                          {t('read')}
                        </button>
                        <button
                          type="button"
                          className="m-0 libelistaButtonBlue py-2 px-3 rounded  text-white text-uppercase"
                        >
                          {t('download')}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Row>
      ) : (
        <NoResults
          text={t('nobookslist')}
          icon={noBooks}
          className='noFavorites'
          showBackToHome={true} />
      )}
    </Container>
  );
};

const MyBooksManager = () => {
  const [boughtBooksData, setBoughtBooksData] = useState(undefined);
  const getUserBoughtBooksHandler = async () => {
    try {
      const response = await getUserBoughtBooks();
      const { status, data } = response;
      if ([200, 201].includes(status) && data?.length) {
        setBoughtBooksData(data);
      }
    } catch (exception) {
      console.log(exception);
    }
  };
  useEffect(() => {
    getUserBoughtBooksHandler();
  }, []);
  return <MyBooks data={boughtBooksData?.flat()} />;
};
export default MyBooksManager;
